<template>
  <div class="auth-page" :class="variantClass">
    <div
      class="auth-page__content d-flex align-items-center justify-content-center min-vh-100"
    >
      <div class="auth-page__card-wrapper w-100">
        <slot />
      </div>
    </div>
    <div v-if="showFooter" class="auth-page__footer text-center">
      <p class="small mb-0">{{ resolvedFooterText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthWrapper',
  props: {
    footerText: {
      type: String,
      default: null,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    /**
     * Adds an `auth-page--<variant>` modifier. Screens that pass nothing keep
     * the shared background; `login` opts into the redesigned light ground.
     */
    variant: {
      type: String,
      default: null,
    },
  },
  computed: {
    variantClass() {
      return this.variant ? `auth-page--${this.variant}` : null;
    },
    resolvedFooterText() {
      if (this.footerText) {
        return this.footerText;
      }
      const year = new Date().getFullYear();
      return `© ${year} Plateforme des enquêtes.`;
    },
  },
};
</script>
